

const state = {
    
    blocks:[
        {
            id:1,
            name:'',
            color:'#fff',
            columns:2,
            blockcomponents: {
                columns: [
                    //left column
                    [
                       
                        {
                            id:2,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Menge",
                                    size:"xs5",
                                    invertedsize:"xs6",
                                    hint:"Menge in kg",
                                    icon:"edit",
                                    variable: 'unitvalue',
                                    setter: 'recipesteps/RECIPESTEP_SET_UNITVALUE',     
                                    rules:"required"
                            }
                        }, 
                        
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Maßeinheit",
                                size:"xs4",
                                invertedsize:"xs7",
                                displaytitle:"name",
                                displaysubtitle:"",
                                multiple:false,
                                icon:"search",
                                variable: 'unit_id',
                                setter: 'recipesteps/RECIPESTEP_SET_UNIT',
                                items:'units/units',
                                withdialog:false,
                            }                                    
                        },
                        {
                            id:2,
                            name:'formsearchinput',
                            attributes: {
                                hint:"Zutat/Rezept",
                                size:"xs6",
                                invertedsize:"xs5",
                                displaytitle:"name",                                    
                                icon:"search",
                                variable: 'ingredient_id',
                                setter: 'recipesteps/RECIPESTEP_SET_INGREDIENT',                                    
                                items:'entities/ingredients',                    
                                rules:"required",
                                lists: [
                                    {
                                        name:"Rezepte",
                                        target:"entities",
                                        variable:'name',
                                        constraint:{
                                            field: "entitycategory_id",
                                            value: "1"
                                        }
                                    },
                                    {
                                        name:"Zutaten",
                                        target:"entities",
                                        variable:'name',
                                        constraint:{
                                            field: "entitycategory_id",
                                            value: "2"
                                        }
                                    },  
                                ]    
                            }
                        },
            
                        
                        /*
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Zutat",
                                size:"xs10",
                                invertedsize:"xs1",
                                displaytitle:"name",
                                displaysubtitle:"",
                                multiple:false,
                                icon:"search",
                                variable: 'ingredient_id',
                                setter: 'recipesteps/RECIPESTEP_SET_INGREDIENT',
                                items:'entities/ingredients',                                   
                                withdialog:false,
                            }                                    
                        },
                        */
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Verarbeitung",
                                size:"xs10",
                                invertedsize:"xs1",
                                displaytitle:"name",
                                displaysubtitle:"",
                                multiple:true,
                                icon:"search",
                                variable: 'treatment_ids',
                                setter: 'recipesteps/RECIPESTEP_SET_TREATMENTS',
                                items:'treatments/treatments',
                                withdialog:false,
                            }                                    
                        }
                    ], 
                    //right column
                    [
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Zubereitung",
                                size:"xs10",
                                invertedsize:"xs1",
                                displaytitle:"text",
                                displaysubtitle:"",
                                multiple:true,
                                icon:"search",
                                variable: 'preparation_ids',
                                setter: 'recipesteps/RECIPESTEP_SET_PREPARATIONS',
                                items:'preparations/preparations',
                                withdialog:true,
                            }                                    
                        },
                        {
                            id:2,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Garverlust",
                                    size:"xs5",
                                    invertedsize:"xs6",
                                    hint:"Garverlust",
                                    icon:"edit",
                                    variable: 'cookingloss',
                                    setter: 'recipesteps/RECIPESTEP_SET_COOKINGLOSS',                                    
                            }
                        }, 
                        {
                            id:2,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Rüstverlust",
                                    size:"xs5",
                                    invertedsize:"xs6",
                                    hint:"Rüst-/ Schälverlust",
                                    icon:"edit",
                                    variable: 'prepareloss',
                                    setter: 'recipesteps/RECIPESTEP_SET_PREPARELOSS',                                    
                            }
                        }, 
                        
                                                                                    
                    ],  
                    
                ]
            }
        }
    ]

};

export default {
  namespaced: false,
  state,
  
};

                     
                    